import { ErrorBoundary } from '@sentry/react';
import { Stacked } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { Suspense } from 'react';
import { unwrappedPlayerMetricsAtom } from '@/atoms/metric/playerMetrics';
import { playerAggsCountSuspenseAtom } from '@/atoms/queries/player/playerAggData';
import { teamSquadWithLoadingAtom, unwrappedTeamSquadCountAtom } from '@/atoms/queries/team/teamSquadData';
import { unwrappedVisibleTableColumnsAtom } from '@/atoms/table';
import { GeneralErrorBoundaryFallback } from '@/components/errorBoundary/ErrorBoundaryFallback';
import { RankDataPillLegend } from '@/components/radar/table/RankDataPillLegend';
import { AggsTable } from './AggsTable';
import { AggsTableErrorFallback } from './AggsTableErrorFallback';
import { TablePagination } from './TablePagination';

const TeamSquadTableWithData = () => {
  const { data, isLoading } = useAtomValue(teamSquadWithLoadingAtom);
  const visibleColumns = useAtomValue(unwrappedVisibleTableColumnsAtom);
  const totalCount = useAtomValue(playerAggsCountSuspenseAtom);
  const playerMetrics = useAtomValue(unwrappedPlayerMetricsAtom);

  return (
    <AggsTable
      data={data}
      isLoading={isLoading}
      visibleColumns={visibleColumns}
      entity="player"
      metricData={playerMetrics}
      totalCount={totalCount}
      withVideo
    />
  );
};

export const TeamSquadTable = () => (
  <AggsTableErrorFallback>
    <Suspense fallback={<AggsTable isLoading entity="player" />}>
      <TeamSquadTableWithData />
    </Suspense>
  </AggsTableErrorFallback>
);

export const TeamSquadTableWithPagination = () => {
  const resultsCount = useAtomValue(unwrappedTeamSquadCountAtom);

  return (
    <ErrorBoundary fallback={<GeneralErrorBoundaryFallback />}>
      <Stacked direction="column" gap="medium">
        <TeamSquadTable />
        <TablePagination dataLengthAtom={playerAggsCountSuspenseAtom} />
        <RankDataPillLegend resultsCount={resultsCount} />
      </Stacked>
    </ErrorBoundary>
  );
};
